'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Text } from '../text';
import { ProgressStepperStepContext } from './context/progress-stepper-step.context';
import { progressStepperStepLabelTextRecipe } from './styles/progress-stepper-step-label-text.styles';
import type { ProgressStepperStepLabelTextPropsInterface } from './types/progress-stepper-step-label-text.types';

/**
 * ProgressStepper.StepLabel's text container
 *
 * @since 8.57.0
 */
export const ProgressStepperStepLabelText = forwardRef<
  HTMLDivElement,
  ProgressStepperStepLabelTextPropsInterface
>((props: ProgressStepperStepLabelTextPropsInterface, forwardedRef) => {
  const { children, css: cssProp, ...rest } = props;

  const { active, interactive, tone } = useContext(ProgressStepperStepContext);
  const variant = active ? 'active' : tone || 'notStarted';

  return (
    <Text
      data-c11n-component="ProgressStepper.StepLabelText"
      data-c11n-version={__C11N_VERSION__}
      css={css.raw(
        progressStepperStepLabelTextRecipe.raw({ active, interactive, variant }),
        cssProp,
      )}
      ref={forwardedRef}
      {...rest}
      className={cx('c11n_progress-stepper__step-label-text', rest.className)}
    >
      {children}
    </Text>
  );
});

ProgressStepperStepLabelText.displayName = 'ProgressStepper.StepLabelText';
